@if (cartridgeRole.limits; as limits) {
  <section class="limits-reached-container">
    <!-- negative values means the limit has been exceeded -->
    @if ((limits.availableSlots ?? 1) <= 0) {
      <div class="variant-assignment-max-limit-reached">
        <markant-icon
          id="{{ cartridgeRole.id }}-max-limit-reached-icon"
          icon="m_warning-small"
          colorScheme="primary"
        ></markant-icon>
        <markant-tooltip
          for="{{ cartridgeRole.id }}-max-limit-reached-icon"
          placement="top"
          trigger="mouseenter"
          colorScheme="dark"
          [label]="
            'cartridge.roles.assignment.limits.maxCapacityReachedTooltip'
              | transloco
          "
        ></markant-tooltip>
        <span>
          {{
            'cartridge.roles.assignment.limits.maxCapacityReachedLabel'
              | transloco
                : {
                    maxSlots: limits.limit,
                  }
          }}
        </span>
      </div>
    } @else if (
      limits.availableSlots &&
      (flow === cartridgeRoleAssignmentFlow.Add ||
        flow === cartridgeRoleAssignmentFlow.ReadOnly)
    ) {
      <span class="variant-assignment-limits">
        {{
          'cartridge.roles.assignment.limits.employeeSlotsAvailable'
            | transloco
              : {
                  availableSlots: limits.availableSlots,
                  maxSlots: limits.limit,
                }
        }}
      </span>
    }

    @if (
      flow === cartridgeRoleAssignmentFlow.Add &&
      (slotsAlreadyAssignedForUser || slotsAlreadyAssignedForGroup)
    ) {
      <div class="slots-in-use-icon">
        <markant-icon
          id="{{ cartridgeRole.id }}-slots-already-in-use"
          icon="m_info-small"
          colorScheme="primary"
        ></markant-icon>
        <markant-tooltip
          for="{{ cartridgeRole.id }}-slots-already-in-use"
          placement="top"
          trigger="mouseenter"
          colorScheme="dark"
          [label]="
            'cartridge.roles.assignment.limits.' +
              slotsAlreadyInUseTranslationKey | transloco
          "
        ></markant-tooltip>
      </div>
    }
  </section>
}
